<template>
    <Header12 />
    <div class="body">
        <section class="background-bleu">
            <MenuTitle title="Groupe d’analyses de pratiques (GAP)" subTitle=""
                srcImg="/images/pages/gap/desc-picture.png" backgroundSpan="span-background-blue-long" />
        </section>
        <section>
            <NavLeft tab="gap" breadcrumb1="" breadcrumb2="Groupe d’analyses de pratiques (GAP)" />
        </section>
        <section class="background-bleu">
            <Expertises />
        </section>
        <section>
            <NousContacter />
        </section>
        <section>
            <Footer :dark_bg="true" />
        </section>
    </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
    title: "EMCI - Groupe d'analyse de pratiques (GAP)",
    meta: [
        {
            name: "description",
            content: "Devenus obligatoires dans les lieux d’accueil de jeunes enfants, les groupes d’analyse de pratiques (GAP) permettent aux professionnels de dénouer leur implication personnelle, relationnelle, affective de leur posture professionnelle."
        }
    ]
})
</script>

<style scoped>
.body {
    overflow: hidden !important;
    margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
    .body {
        margin-top: 85px;
    }

    .background-bleu {
        margin-bottom: 50px;
    }
}
</style>